module.exports = __webpack_public_path__ + "static/media/ic-check-teal.c340b78d.svg";